import styled from "styled-components";
import { ListChecks, Brain, Route } from "lucide-react";
const HowSection = styled.section`
  padding: 120px 24px;
  background: linear-gradient(
    180deg,
    rgba(56, 189, 248, 0.06),
    transparent 40%
  );
`;

const HowContainer = styled.div`
  max-width: 1100px;
  margin: auto;
  text-align: center;
`;

const HowTitle = styled.h2`
  font-size: clamp(28px, 4vw, 38px);
  font-weight: 900;
  line-height: 1.2;
  margin-bottom: 18px;
`;

const HowSub = styled.p`
  font-size: 17px;
  line-height: 1.7;
  color: #9ca3af;
  max-width: 720px;
  margin: 0 auto 70px;
`;

const StepsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 30px;
`;

const StepCard = styled.div`
  padding: 30px;
  border-radius: 20px;
  background: rgba(15, 23, 42, 0.62);
  border: 1px solid rgba(148, 163, 184, 0.1);
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(245, 158, 11, 0.24);
    box-shadow: 0 24px 70px rgba(245, 158, 11, 0.12);
  }
`;

const StepIcon = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #f59e0b, #38bdf8);
  margin: 0 auto 18px;
`;

const StepTitle = styled.h3`
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 10px;
`;

const StepText = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: #9ca3af;
`;

export function HowItWorks() {
  return (
    <HowSection>
      <HowContainer>
        <HowTitle>How the Career Clarity Test works</HowTitle>

        <HowSub>
          No tricks. No psychology games. Just a focused signal check that
          helps us turn your confusion into direction and your direction into a
          roadmap.
        </HowSub>

        <StepsGrid>
          <StepCard>
            <StepIcon>
              <ListChecks size={26} />
            </StepIcon>
            <StepTitle>Answer focused questions</StepTitle>
            <StepText>
              Quick questions about your experience, interests, current level,
              and where you actually want growth or a job.
            </StepText>
          </StepCard>

          <StepCard>
            <StepIcon>
              <Brain size={26} />
            </StepIcon>
            <StepTitle>We analyze your signals</StepTitle>
            <StepText>
              Your answers reveal patterns: what you are suited for, where the
              gaps are, and what direction makes the most sense now.
            </StepText>
          </StepCard>

          <StepCard>
            <StepIcon>
              <Route size={26} />
            </StepIcon>
            <StepTitle>You get a clear path</StepTitle>
            <StepText>
              You get a recommended path, a current-level snapshot, and the
              next focus areas that should shape your roadmap.
            </StepText>
          </StepCard>
        </StepsGrid>
      </HowContainer>
    </HowSection>
  );
}
